// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__36zn3","dragIcon":"SortableItem_dragIcon__16o5Q","disabled":"SortableItem_disabled__3cvcW"};